import React from 'react';

/**
 * @description Left background pattern
 *  - This is used in the job filter page
 *  - The box background seen on the left side of the section
 * @returns {JSX.Element}
 */
function LeftBackGroundPattern() {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='353'
			height='368'
			fill='none'
			viewBox='0 0 353 368'
		>
			<g clipPath='url(#clip0_880_5011)'>
				<path
					fill='#8363E2'
					d='M282.781 309.348c-73.963 66.982-183.503 74.476-271.51 33.257-93.156-43.562-139.968-141.927-122.648-242.166C-94.993 5.821-20.093-81.302 75.872-99.101c12.639-2.343 25.278-.938 36.045 3.746 92.688-18.267 188.653 51.057 224.23 142.396 33.705 87.123 17.321 198.135-53.366 262.307zM237.842 80.766c-7.958-21.078-25.747-44.967-44.004-57.614-19.661-13.115-57.579-28.573-79.58-11.242-17.789 14.053-40.727 19.673-59.92 9.837-37.45 24.825-63.196 67.45-66.005 111.949-3.277 55.272 27.62 101.175 77.24 119.912 51.962 20.141 111.881 14.989 150.267-24.357 37.45-37.473 41.195-98.834 22.002-148.485z'
				/>
				<path
					fill='#1478C8'
					d='M273.63-10.048c-5.994-13.715-24.236-22.683-38.047-15.298-53.162 28.221-100.07 67.52-129.778 121.06-31.011 55.652-38.047 122.644-15.897 182.778 13.03 35.343 66.192 11.869 53.162-23.473-34.92-94.95 36.745-184.888 115.706-226.56 13.812-7.121 21.369-23.21 14.854-38.507z'
				/>
			</g>
			<defs>
				<clipPath id='clip0_880_5011'>
					<rect width='353' height='368' fill='#fff' rx='12' />
				</clipPath>
			</defs>
		</svg>
	);
}

export default LeftBackGroundPattern;
